export const LoadingPlaces = () => {
	return (
		<div className='alert alert-primary mt-2 text-center'>
			<h6>Searching</h6>
			<p>Please wait...</p>
		</div>
	);
};
